import React from "react";
import { BiSearch } from "react-icons/bi";

const SearchBar = ({ searchTerm, setSearchTerm, setSearchData }) => {
  return (
    <div className="relative max-w-md w-full">
      <input
        type="text"
        className="max-w-md w-full px-4 py-2 border rounded-lg focus:outline-none"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setSearchData(searchTerm);
          }
        }}
      />
      <button
        type="button"
        className="absolute top-0 right-0 px-4 h-full bg-[#124699] text-white rounded-r-lg"
        onClick={() => setSearchData(searchTerm)}
      >
        <BiSearch />
      </button>
    </div>
  );
};

export default SearchBar;
